import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import "../styles/LearnerDashboard.css";
import { learnerMenuItems } from "../components/TeacherMenuItems"; // Import menu items
import LearnerFeedback from "../components/LearnerFeedback";

// import tutorials from "../images/tutorials.png";
// import history from "../images/history.png";
import TeacherStudentHeader from "../components/TeacherStudentHeader";
import AccessTokenModal from "../components/AccessTokenModal";

const LearnerFeedbackPage = () => {
  const [activeItem, setActiveItem] = useState("feedback");
  const [isVideoMode, setIsVideoMode] = useState(true);
  const [searchQuery, setSearchQuery] = useState(""); // Store search query
  const navigate = useNavigate(); // Initialize useNavigate

  const resetSearch = () => {
    setSearchQuery(""); // Reset the search query
  };

  const getHeaderVisibility = () => {
    if (activeItem === "home" || activeItem === "") {
      return { showSearch: true, showToggle: true, showUserProfile: true };
    } else if (activeItem === "feedback") {
      return { showSearch: false, showToggle: false, showUserProfile: true };
    } else if (activeItem === "tutorials") {
      return { showSearch: true, showToggle: false, showUserProfile: true };
    }
    return { showSearch: false, showToggle: false, showUserProfile: true };
  };

  const toggleMode = (mode) => {
    setIsVideoMode(mode);
  };

  // Reset search when switching tabs

  const handleActiveItemChange = (item) => {
    setActiveItem(item); // Update active item

    // Navigate to the correct route
    if (item === "feedback") {
      navigate("/learner/feedback"); // Navigate to feedback page
    } else if (item === "home") {
      navigate("/learner"); // Navigate to home page
    }

    resetSearch(); // Reset search whenever a new section is selected
  };
  // Fetching the current visibility for the header components
  const { showSearch, showToggle, showUserProfile } = getHeaderVisibility();

  return (
    <div className="dashboard">
      <TeacherStudentHeader
        isVideoMode={isVideoMode}
        toggleMode={toggleMode}
        showSearch={showSearch}
        showToggle={showToggle}
        showUserProfile={showUserProfile}
        searchQuery={searchQuery}
        // onSearch={handleSearch}
        teacherMenuItems={learnerMenuItems}
        activeItem={activeItem} // Pass activeItem
        setActiveItem={handleActiveItemChange}
        // Pass setActiveItem
      />
      <main className="main-content">
        {/* <Sidebar
          activeItem={activeItem} // Highlight the correct active item
          setActiveItem={handleActiveItemChange} // Change active item when clicked
          menuItems={learnerMenuItems}
          resetSearch={resetSearch} // Reset search when switching tabs
        /> */}

        <div className="content">
          <div className="feedback-form">
            <LearnerFeedback />
          </div>
        </div>
      </main>
      <AccessTokenModal />
    </div>
  );
};

export default LearnerFeedbackPage;
